<template>
	<div class="app">
		<Card dis-hover style="min-height:400px;">
			<Form ref="queryForm" :label-width="80" label-position="left" inline>
				<Row :gutter="20">
					<FormItem label="客户简名:">
						<Select v-model="query.customerJMsList" multiple style="width: 160px">
							<Option :value="jm.value" v-for="(jm,index) in customerJMList" :key="index">{{jm.name}}
							</Option>
						</Select>
					</FormItem>
					<FormItem label="投标时间:">
						<DatePicker v-model="query.biddingTime" type="daterange" @on-change="dateChange"
							style="width: 260px" placement="bottom-end" placeholder="请选择"></DatePicker>
					</FormItem>
					<FormItem label="业务员:">
						<Select v-model="query.salesmansList" multiple style="width: 160px">
							<Option :value="item.value" v-for="(item,index) in salesmanList" :key="index">{{item.name}}
							</Option>
						</Select>
					</FormItem>
					<!-- <FormItem :label-width="20"> -->
					<Button icon="ios-search" type="primary" size="default" @click="getpage(1)"
						class="toolbar-btn">查询</Button>
					<Button icon="md-refresh" type="primary" size="default" @click="reset"
						class="toolbar-btn">重置</Button>
					<Button icon="md-add" type="primary" size="default" @click="openCreateLog"
						class="toolbar-btn">新增</Button>
					<Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate"
						class="toolbar-btn">下载导入模板</Button>
					<Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile"
						:headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action"
						:data="importData">
						<Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
					</Upload>
					<Button type="success" icon="md-archive" @click="exportFile" class="toolbar-btn">导出</Button>
				</Row>
				<!-- </FormItem> -->
				<!-- </Row> -->
			</Form>
			<div>
				<Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
				<Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10"
					@on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize"
					:current="currentPage"></Page>
			</div>
		</Card>
		<div v-if="createLogModelShow">
			<createBid :show="createLogModelShow" @close="closeModel" :showZB="showZB"
				:departmentType="$constDefinition.ODM事业部" :customerId="customerId" :quotationId="quotationId">
			</createBid>
		</div>
		<div v-if="createLogModelZBShow">
			<createBidZB :show="createLogModelZBShow" @close="closeModel" :departmentType="$constDefinition.ODM事业部"
				:customerId="customerId" :quotationId="quotationId"></createBidZB>
		</div>
		<Modal title="操作日志" :value="detailLogShow" @on-cancel="closeModel" @on-ok="closeModel()" :mask-closable="false"
			width="600">
			<div class="project">
				<!-- 操作日志 -->
				<Timeline>
					<TimelineItem v-for="(log,index) in form.businessLogList" :key="index">
						<p class="time">{{log.creatorName}}<span
								style="margin-left:10px;color:#b6b6b6;">{{log.creationTimeText}}</span></p>
						<p class="content">{{log.content}}</p>
					</TimelineItem>
				</Timeline>
			</div>
			<Spin size="large" fix v-show="spinShow"></Spin>
		</Modal>
	</div>
</template>
<script>
	import Util from '../../../lib/util'
	import moment from 'moment'
	import createBid from './createBid.vue'
	import createBidZB from './createBidZB.vue'
	export default {
		name: 'bidODM',
		components: {
			createBid,
			createBidZB
		},
		props: {
			show: Boolean,
			customerId: Number,
		},
		data() {
			return {
				model: true,
				query: {
					biddingTime: [],
					customerJMs: '',
					salesmans: '',
					customerJMsList: [],
					salesmansList: [],
					biddingTimeStart: '',
					biddingTimeEnd: '',
					departmentType: this.$constDefinition.ODM事业部,
					// customerId: this.customerId,
				},
				header: {
					Authorization: `Bearer ${Util.abp.auth.getToken()}`,
				},
				requestHeader: {
					Authorization: `Bearer ${Util.abp.auth.getToken()}`,
				},
				importData: {
					departmentType: this.$constDefinition.ODM事业部,
				},
				action: this.$constDefinition.baseUrl + `/Customerfile/UploadBid?departmentType=${this.$constDefinition.ODM事业部}`,
				columns: [], //项目表头
				list: [], //项目数据
				customerJMList: [],
				salesmanList: [],
				form: [],
				detailLogShow: false,
				spinShow: false,
				pageSize: 10,
				quotationId: null,
				currentPage: 1,
				totalCount: 0,
				loading: false,
				createLogModelShow: false,
				createLogModelZBShow: false,
				showZB: false,
			}
		},
		mounted() {
			this.getColumns()
			this.getSelectList()
			this.getpage(1)
		},
		methods: {
			getColumns() {
				this.columns = [{
						title: '事业部',
						key: 'departmentTypeText',
						width: 120,
					},
					{
						title: '客户简名',
						key: 'simpleName',
						render: (h, params) => {
							return h('span', params.row.customer.simpleName)
						},
						width: 120,
					},
					{
						title: '招标时间',
						key: 'biddingTimeText',
						width: 120,
					},
					{
						title: '客户物料编码',
						key: 'materialCode',
						width: 150,
					},
					{
						title: '产品名称',
						key: 'productName',
						width: 150,
					},
					{
						title: '投标金额',
						key: 'bidAmountText',
						width: 150,
					},
					{
						title: '业务员',
						key: 'salesmanText',
						width: 120,
					},
					{
						title: '是否中标',
						key: 'isSuccessfulBidText',
						width: 100,
					},
					{
						title: '中标单位',
						key: 'winningBidder',
						width: 150,
					},
					{
						title: '中标价格',
						key: 'bidWinningPriceText',
						width: 150,
					},
					{
						title: '成本',
						key: 'costText',
						width: 150,
					},
					{
						title: '毛利率',
						key: 'grossMarginText',
						width: 100,
					},
					{
						title: '创建时间',
						width: 180,
						key: 'creationTimeText',
					},
					{

						title: '操作',
						width: 180,
						fixed: 'right',
						render: (h, params) => {
							return h('div', [
								h(
									'Button', {
										props: {
											type: 'primary',
											size: 'small',
										},
										style: {
											marginRight: '5px',
										},
										on: {
											click: () => {
												this.openShowLog(params.row.id)
											},
										},
									},
									'操作日志'
								),
								h(
									'Button', {
										props: {
											type: 'primary',
											size: 'small',
										},
										style: {
											marginRight: '5px',
											// display: params.row.isEdit ? '' : 'none',
										},
										on: {
											click: () => {
												this.openCreateProduct(params.row)
											},
										},
									},
									'编辑'
								),
								h(
									'Button', {
										props: {
											type: 'primary',
											size: 'small',
										},
										style: {
											marginRight: '5px',
											display: params.row.isShow补充中标信息 ? '' : 'none',
										},
										on: {
											click: () => {
												this.openCreateProductZB(params.row.id)
											},
										},
									},
									'补充中标信息'
								),
								h(
									'Button', {
										props: {
											type: 'error',
											size: 'small',
										},
										style: {
											marginRight: '5px',
										},
										on: {
											click: () => {
												this.$Modal.confirm({
													title: '确认删除这条记录吗？',
													okText: '确认',
													cancelText: '取消',
													onOk: async () => {
														const {
															data
														} = await this.$Ajax.delete(
															`/api/services/app/CustomerBidApiService/Delete?id=${params.row.id}`
														)
														if (data.success) {
															this.$Message.success({
																content: '删除成功',
																duration: 5
															})
														} else {
															this.$Message.error({
																content: '删除失败',
																duration: 5
															})
														}
														this.getpage()
													},
												})
											},
										},
									},
									'删除'
								),



							])
						},
					},

				]
			},
			//   获取下拉框数据
			async getSelectList() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerBidApiService/GetBidMgrInitData?departmentType=${this.$constDefinition.ODM事业部}`
				)
				this.customerJMList = data.result.customerJMData
				this.salesmanList = data.result.salesmanData
			},
			//新增日志
			openCreateLog() {
				this.showZB = false
				this.createLogModelShow = true
			},
			//时间改变
			dateChange() {
				let time = this.query.biddingTime
				let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
				let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
				this.query.biddingTimeStart = start
				this.query.biddingTimeEnd = end
			},
			// 导入前处理
			beforeImportFile() {
				this.spinShow = true
			},
			// 导入成功
			importFile() {
				this.$Message.success({
					content: '导入成功',
					duration: 3,
				})
				this.getpage()
				this.spinShow = false
			},
			// 导入失败
			errorImportFile(error, file, fileList) {
				this.$Message.error({
					content: file.error.message,
					duration: 3,
				})
				this.getpage()
				this.spinShow = false
			},
			// 下载导入模板
			downLoadTemplate() {
				this.downloadFile('/Customerfile/DownloadBidModel', '导入客户招投标记录模板')
			},
			exportFile() {
				var _this = this
				this.$downLoad(
					'/api/Export/ExportCustomerBid',
					'客户招投标记录',
					'.xlsx',
					this.query
				)
			},
			downloadFile(url, title) {
				const date = moment(new Date()).format('yyyyMMDDHHmm')
				let _this = this
				let consturl = this.$constDefinition.baseUrl + url //下载地址url
				var xhr = new XMLHttpRequest()
				xhr.open('get', consturl, true) // get、post都可
				xhr.responseType = 'blob'
				xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
				xhr.onload = function() {
					console.log(xhr)
					if (xhr.status == 200) {
						let blob = new Blob([this.response], {
							type: 'application/vnd.ms-excel',
						})
						var a = document.createElement('a')
						var url = window.URL.createObjectURL(blob)
						a.href = url
						a.download = title + date + '.xlsx' // 文件名
						if (xhr.readyState === 4) {
							_this.$Message.success({
								content: '下载成功',
								duration: 3,
							})
						}
					} else {
						_this.$Message.error({
							content: '下载失败',
							duration: 3,
						})
					}
					a.click()
					window.URL.revokeObjectURL(url)
				}
				xhr.send()
			},
			async getpage(params) {
				this.query.MaxResultCount = this.pageSize
				this.query.SkipCount = (this.currentPage - 1) * this.pageSize
				if (params === 1) {
					this.query.SkipCount = 0
				}
				if (this.query.customerJMsList.length > 0)
					this.query.customerJMs = this.query.customerJMsList.join(',')
				if (this.query.salesmansList.length > 0)
					this.query.salesmans = this.query.salesmansList.join(',')
				this.loading = true
				const data = await this.$Ajax.get('/api/services/app/CustomerBidApiService/QueryDto', {
					params: this.query,
				})
				this.list = data.data.result.items
				this.totalCount = data.data.result.totalCount
				this.loading = false
			},
			pageChange(page) {
				this.currentPage = page
				this.getpage()
			},
			pagesizeChange(pagesize) {
				this.pageSize = pagesize
				this.getpage()
			},
			// 创建产品
			openCreateProduct(row) {
				this.quotationId = row.id
				if (row.isSuccessfulBid != null) {
					this.showZB = true
				} else
					this.showZB = false
				this.createLogModelShow = true
			},
			// 创建产品
			openCreateProductZB(quotationId) {
				this.quotationId = quotationId
				this.createLogModelZBShow = true
			},
			// 创建产品
			async openShowLog(quotationId) {
				this.detailLogShow = true
				const data = await this.$Ajax.get(`/api/services/app/CustomerBidApiService/GetDetailInfoById?id=` +
					quotationId)
				this.form = {
					...data.data.result
				}
				this.spinShow = false
			},
			reset() {
				this.query = {
					biddingTime: [],
					customerJMs: '',
					salesmans: '',
					customerJMsList: [],
					salesmansList: [],
					biddingTimeStart: '',
					biddingTimeEnd: '',
					departmentType: this.$constDefinition.ODM事业部,
				}
				this.getpage(1)
			},
			//关闭弹框
			closeModel() {
				this.createLogModelShow = false
				this.createLogModelZBShow = false
				this.detailLogShow = false
				this.quotationId = null
				this.getpage()
			},
		},
	}
</script>
<style lang="less" scoped>
	// /deep/.ivu-modal-fullscreen {
	//   width: calc(~'100% - 256px') !important;
	//   top: 0;
	//   bottom: 0;
	//   position: absolute;
	//   left: 256px;
	// }
</style>